import MasterTab from 'src/components/Layouts/MasterTab.vue';
import Opt from "src/views/Pages/Dashboard/Grow/Captures/OPT/Opt.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const OptRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'optcapture',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.opt',
          component: Opt,
          meta: {
            prefix_permission: 'grow_opt',
          },
        },
      ],
    },
  ],
};

export default OptRoutes;
